import React, { useEffect } from 'react';
import FVHeader from '../components/public/FVHeader';
import Styled from '../styles/public/FerramentaVideoPublic.styled';
import { QueryObserverRefetchErrorResult, QueryObserverSuccessResult } from 'react-query'; // adjust import if needed
import { IFVContainer } from '../interfaces/FVContainer.interface';
import { bucketS3, caminhoAnexosFerramentaVideo, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';
import { FaHands } from 'react-icons/fa6';
import { IoHeadset } from 'react-icons/io5';
import Cookies from 'js-cookie';
import { YellowButton } from 'components/UI/Buttons';
import keycloak from 'core/config/keycloak';
import { TextDangerouslySetInnerHtml } from 'pages/recursos/recursos-conteudo/RecursosConteudoPage.styled';
import { useHistory } from 'react-router-dom';
import Colors from 'enums/Colors';
import { IFVRole } from '../interfaces/FVRole.interface';
import Loading from 'components/Loading';
import { loadImageHelper } from 'helpers/ImageHelpers';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';

interface FVInitialAccessProps {
    // ...other props (history, location, match, etc.)...
    listFerramenta: QueryObserverRefetchErrorResult<IFVContainer, unknown> | QueryObserverSuccessResult<IFVContainer, unknown>;
    roles: IFVRole[] | null;
    handleRedirect?: () => void;
}

const FVInitialAccess: React.FC<FVInitialAccessProps> = props => {
    const history = useHistory();

    const [fetchedData, setFetchedData] = React.useState<IFVContainer | null>(null);
    const [fetchedRoles, setFetchedRoles] = React.useState<IFVRole[] | null>(null);

    const [imgSolucao, setSolucao] = React.useState<string>('');
    const [imgLoading, setImgLoading] = React.useState<boolean>(false);

    const getBucketGeneralFiles = () => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };
    const getBucketFerramentaVideo = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    const handleMenuChange = (menu: string) => {
        Cookies.set('menuTypePackage', menu, { expires: 365, path: '/' });
    };

    const goToHome = () => {
        history.replace(`/videos/${props.listFerramenta.data?.url}/home`);
    };

    useEffect(() => {
        if (props.listFerramenta.data) {
            setFetchedData(props.listFerramenta.data);
        }
    }, [props.listFerramenta.data]);

    useEffect(() => {
        if (props.roles) {
            setFetchedRoles(props.roles);
        }
    }, [props.roles]);

    // Load image when fetchedData changes
    useEffect(() => {
        if (fetchedData && fetchedData.codigoSolucao?.logo) {
            setImgLoading(true);
            loadImageHelper(getBucketGeneralFiles() + fetchedData.codigoSolucao.logo)
                .then(src => setSolucao(src))
                .catch(() => setSolucao(''))
                .finally(() => setImgLoading(false));
        } else {
            setSolucao('');
            setImgLoading(false);
        }
    }, [fetchedData]);

    return (
        <Styled.InitialAccess.Container>
            <Styled.InitialAccess.Content>
                <Styled.InitialAccess.Block style={{ gap: 0 }}>
                    {fetchedRoles && fetchedRoles?.length > 0 && (
                        <Styled.InitialAccess.Footer.Container>
                            <TextDangerouslySetInnerHtml
                                style={{ maxWidth: '800px', color: Colors.Blue }}
                                dangerouslySetInnerHTML={{ __html: fetchedRoles != null ? fetchedRoles?.[0].description ?? '' : '' }}
                            />
                        </Styled.InitialAccess.Footer.Container>
                    )}
                </Styled.InitialAccess.Block>
                <Styled.InitialAccess.Block>
                    <Styled.InitialAccess.ContainerImg style={{ position: 'relative', minHeight: 120, minWidth: 120 }}>
                        {imgLoading ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 2,
                                }}
                            >
                                <Loading />
                            </div>
                        ) : null}
                        <Styled.InitialAccess.ImgSolucoes
                            src={imgSolucao}
                            alt="Imagem da Ferramenta de Vídeo"
                            style={{ opacity: imgLoading ? 0.3 : 1, transition: 'opacity 0.2s' }}
                        />
                    </Styled.InitialAccess.ContainerImg>
                    {fetchedData?.notAccessibility ? (
                        <ButtonHomeV2
                            onClick={goToHome}
                            style={{
                                borderRadius: '8px',
                                height: '52px',
                                maxHeight: '52px',
                                fontSize: 20,
                                textTransform: 'uppercase',
                                width: '98%',
                            }}
                        >
                            Acessar
                        </ButtonHomeV2>
                    ) : (
                        <>
                            <Styled.InitialAccess.Title>COMO DESEJA ASSISTIR?</Styled.InitialAccess.Title>
                            <Styled.InitialAccess.ButtonsContainer>
                                <Styled.InitialAccess.Button
                                    onClick={() => {
                                        handleMenuChange('libras');
                                        goToHome();
                                    }}
                                    aria-label="Assistir vídeo em libras"
                                >
                                    <FaHands size={42} /> Em Libras
                                </Styled.InitialAccess.Button>
                                <Styled.InitialAccess.Button
                                    onClick={() => {
                                        handleMenuChange('audio');
                                        goToHome();
                                    }}
                                    aria-label="Assistir vídeo com audiodescrição"
                                >
                                    {' '}
                                    <IoHeadset size={42} /> audiodescrição
                                </Styled.InitialAccess.Button>
                            </Styled.InitialAccess.ButtonsContainer>
                        </>
                    )}
                    <YellowButton
                        style={{ borderRadius: '8px', height: '52px', maxHeight: '52px', fontSize: 20, textTransform: 'uppercase' }}
                        aria-label="Sair da plataforma de vídeos"
                        onClick={props.handleRedirect}
                    >
                        Sair
                    </YellowButton>
                </Styled.InitialAccess.Block>
            </Styled.InitialAccess.Content>
            {fetchedRoles && fetchedRoles?.length > 0 && (
                <Styled.InitialAccess.Footer.Container style={{ width: '100%' }}>
                    <Styled.InitialAccess.Footer.ReguaLogo
                        style={{ backgroundColor: Colors.White }}
                        src={fetchedData ? getBucketFerramentaVideo() + fetchedRoles?.[0].filePathRegua : ''}
                    />
                </Styled.InitialAccess.Footer.Container>
            )}
        </Styled.InitialAccess.Container>
    );
};

export default FVInitialAccess;
